import React, { useState } from 'react';
import './CastingApplicationPage.css';

function CastingApplicationPage({ onNavigate }) {
  const [currentStep, setCurrentStep] = useState(1);
  const [submitting, setSubmitting] = useState(false);
  const [consentChecked, setConsentChecked] = useState(false); // ⭐ ДОДАНО

  const [formData, setFormData] = useState({
    fullName: '',
    birthYear: '',
    countryOfOrigin: '',
    currentCity: '',
    email: '',
    phone: '',
    primaryLanguage: '',
    otherLanguages: '',
    englishProficiency: '',
    otherLanguageProficiency: '',
    instagram: '',
    portfolioLink: '',
    otherSocial: '',
    education: '',
    occupation: '',
    runwayExperience: '',
    runwayEvents: '',
    brandExperience: '',
    brandList: '',
    height: '',
    bust: '',
    waist: '',
    hips: '',
    shoeSize: '',
    dressSize: '',
    hairColor: '',
    eyeColor: '',
    usStatus: '',
    passports: '',
    multipleNationalities: '',
    travelUSA: '',
    travelIntl: '',
    overviewReceived: '',
    videoReceived: '',
    wantsToParticipate: '',
    understandingDescription: '',
    ownedBusiness: '',
    businessDescription: '',
    wantsBusiness: '',
    hasIdea: '',
    ideaDescription: '',
    hasPlan: '',
    employmentStatus: '',
    employer: '',
    weeklyAvailability: '',
    contractType: '',
    headshot: '',
    fullBody: '',
    portfolioImages: [],
    introVideo: ''
  });
  
const getOrCreateGenesisID = () => {
  const currentUser = JSON.parse(localStorage.getItem('currentUser'));
  
  if (currentUser && currentUser.genesisID) {
    return currentUser.genesisID;
  }
  
  let wandererID = localStorage.getItem('wandererGenesisID');
  
  if (!wandererID) {
    const randomNumber = Math.floor(1000000 + Math.random() * 9000000);
    wandererID = `W${randomNumber}`;
    localStorage.setItem('wandererGenesisID', wandererID);
  }
  
  return wandererID;
};


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

const compressImage = (file, quality = 0.7) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        
        // Зберегти пропорції, але максимум 1920px по ширині
        let width = img.width;
        let height = img.height;
        
        if (width > 1920) {
          height = (height * 1920) / width;
          width = 1920;
        }
        
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);
        
        canvas.toBlob((blob) => {
          resolve(new File([blob], file.name, { 
            type: 'image/jpeg',
            lastModified: Date.now()
          }));
        }, 'image/jpeg', quality);
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });
};

// ✅ ОНОВЛЕНА handleFileUpload
const handleFileUpload = async (e) => {
  const { name, files } = e.target;
  const genesisID = getOrCreateGenesisID();
  
  const uploads = name === 'portfolioImages' ? Array.from(files) : [files[0]];
  const uploadedUrls = [];

  for (let file of uploads) {
    // ✅ АВТОМАТИЧНЕ COMPRESS для великих фото
    if (file.type.startsWith('image/') && file.size > 5 * 1024 * 1024) {
      console.log(`📸 Compressing ${file.name} (${(file.size / 1024 / 1024).toFixed(2)}MB)...`);
      file = await compressImage(file, 0.75); // 75% якість
      console.log(`✅ Compressed to ${(file.size / 1024 / 1024).toFixed(2)}MB`);
    }
    
    const formDataUpload = new FormData();
    formDataUpload.append('file', file);
    formDataUpload.append('genesisID', genesisID);
    formDataUpload.append('fieldName', name);

    const res = await fetch('https://56ck1hlaxh.execute-api.us-east-1.amazonaws.com/uploadMediaToS3', {
      method: 'POST',
      body: formDataUpload
    });

    const result = await res.json();
    uploadedUrls.push(result.fileUrl);
  }

  setFormData(prev => ({
    ...prev,
    [name]: name === 'portfolioImages' ? uploadedUrls : uploadedUrls[0]
  }));
};

  const handleSubmit = async () => {
    if (!consentChecked) {
      alert('Please confirm consent checkbox');
      return;
    }

    setSubmitting(true);
    try {
      const genesisID = getOrCreateGenesisID(); // ⭐ ВИКОРИСТОВУЄМО НОВУ ФУНКЦІЮ

      // Крок 1: Зберегти application в БД
      const response = await fetch('https://1kn7g0vf8j.execute-api.us-east-1.amazonaws.com/submitCastingApplication', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          genesisID: genesisID, // ⭐ ПЕРЕДАЄМО W-ID
          formData
        })
      });

      const result = await response.json();
      
      if (result.success) {
        // Крок 2: Генерувати PDF сертифікат і відправити на email
        const certificateResponse = await fetch('https://orkxz4jpah.execute-api.us-east-1.amazonaws.com/generate-casting-certificate', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            genesisID: genesisID, // ⭐ ПЕРЕДАЄМО W-ID
            formData,
            email: formData.email
          })
        });

        const certResult = await certificateResponse.json();
        
        if (certResult.success) {
          alert(`Application submitted successfully! Your Genesis ID: ${genesisID}. Certificate sent to your email.`);
        } else {
          alert('Application saved, but certificate generation failed. Please contact support.');
        }
      }
      
      onNavigate('home');
    } catch (error) {
      console.error('Submission error:', error);
      alert('Failed to submit application');
    } finally {
      setSubmitting(false);
    }
  };

  const renderSection = () => {
    switch (currentStep) {
      case 1:
        return (
          <div className="form-section">
            <h3><span className="section-number">1</span> Personal Information</h3>
            
            <div className="form-row">
              <div className="form-group">
                <label>Full Name *</label>
                <input 
                  name="fullName" 
                  value={formData.fullName} 
                  onChange={handleChange} 
                  required 
                />
              </div>
              <div className="form-group">
                <label>Birth Year *</label>
                <input 
                  name="birthYear" 
                  type="number" 
                  value={formData.birthYear} 
                  onChange={handleChange} 
                  required 
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Country of Origin *</label>
                <input 
                  name="countryOfOrigin" 
                  value={formData.countryOfOrigin} 
                  onChange={handleChange} 
                  required 
                />
              </div>
              <div className="form-group">
                <label>Current City *</label>
                <input 
                  name="currentCity" 
                  value={formData.currentCity} 
                  onChange={handleChange} 
                  required 
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Contact Email *</label>
                <input 
                  name="email" 
                  type="email" 
                  value={formData.email} 
                  onChange={handleChange} 
                  required 
                />
              </div>
              <div className="form-group">
                <label>Phone Number *</label>
                <input 
                  name="phone" 
                  value={formData.phone} 
                  onChange={handleChange} 
                  required 
                />
              </div>
            </div>
          </div>
        );

      case 2:
        return (
          <div className="form-section">
            <h3><span className="section-number">2</span> Language Proficiency</h3>
            
            <div className="form-group">
              <label>Primary Language *</label>
              <input 
                name="primaryLanguage" 
                value={formData.primaryLanguage} 
                onChange={handleChange} 
                required 
              />
            </div>

            <div className="form-group">
              <label>Other Languages</label>
              <input 
                name="otherLanguages" 
                value={formData.otherLanguages} 
                onChange={handleChange} 
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>English Proficiency *</label>
                <select 
                  name="englishProficiency" 
                  value={formData.englishProficiency} 
                  onChange={handleChange}
                  required
                >
                  <option value="">Select</option>
                  <option>Beginner</option>
                  <option>Intermediate</option>
                  <option>Advanced</option>
                  <option>Fluent</option>
                  <option>Native</option>
                </select>
              </div>
              <div className="form-group">
                <label>Other Language Proficiency</label>
                <select 
                  name="otherLanguageProficiency" 
                  value={formData.otherLanguageProficiency} 
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option>Beginner</option>
                  <option>Intermediate</option>
                  <option>Advanced</option>
                  <option>Fluent</option>
                  <option>Native</option>
                </select>
              </div>
            </div>
          </div>
        );

      case 3:
        return (
          <div className="form-section">
            <h3><span className="section-number">3</span> Social Media & Portfolio</h3>
            
            <div className="form-group">
              <label>Instagram Handle</label>
              <input 
                name="instagram" 
                value={formData.instagram} 
                onChange={handleChange} 
                placeholder="@username"
              />
            </div>

            <div className="form-group">
              <label>Portfolio / Website Link</label>
              <input 
                name="portfolioLink" 
                type="url" 
                value={formData.portfolioLink} 
                onChange={handleChange}
                placeholder="https://"
              />
            </div>

            <div className="form-group">
              <label>Other Social Media</label>
              <input 
                name="otherSocial" 
                value={formData.otherSocial} 
                onChange={handleChange}
                placeholder="TikTok, YouTube, etc."
              />
            </div>
          </div>
        );

      case 4:
        return (
          <div className="form-section">
            <h3><span className="section-number">4</span> Education & Occupation</h3>
            
            <div className="form-group">
              <label>Education Level *</label>
              <select 
                name="education" 
                value={formData.education} 
                onChange={handleChange}
                required
              >
                <option value="">Select</option>
                <option>High School</option>
                <option>Associate Degree</option>
                <option>Bachelor's Degree</option>
                <option>Master's Degree</option>
                <option>Doctorate</option>
                <option>Other</option>
              </select>
            </div>

            <div className="form-group">
              <label>Current Occupation</label>
              <input 
                name="occupation" 
                value={formData.occupation} 
                onChange={handleChange}
              />
            </div>
          </div>
        );

      case 5:
        return (
          <div className="form-section">
            <h3><span className="section-number">5</span> Modeling Experience</h3>
            
            <div className="form-group">
              <label>Runway Experience *</label>
              <select 
                name="runwayExperience" 
                value={formData.runwayExperience} 
                onChange={handleChange}
                required
              >
                <option value="">Select</option>
                <option>None</option>
                <option>Some</option>
                <option>Extensive</option>
              </select>
            </div>

            {formData.runwayExperience !== 'None' && (
              <div className="form-group">
                <label>List Events/Shows</label>
                <textarea 
                  name="runwayEvents" 
                  value={formData.runwayEvents} 
                  onChange={handleChange}
                  rows="3"
                />
              </div>
            )}

            <div className="form-group">
              <label>Brand Collaboration Experience *</label>
              <select 
                name="brandExperience" 
                value={formData.brandExperience} 
                onChange={handleChange}
                required
              >
                <option value="">Select</option>
                <option>None</option>
                <option>Some</option>
                <option>Extensive</option>
              </select>
            </div>

            {formData.brandExperience !== 'None' && (
              <div className="form-group">
                <label>List Brands</label>
                <textarea 
                  name="brandList" 
                  value={formData.brandList} 
                  onChange={handleChange}
                  rows="3"
                />
              </div>
            )}
          </div>
        );

      case 6:
        return (
          <div className="form-section">
            <h3><span className="section-number">6</span> Physical Measurements</h3>
            
            <div className="form-row">
              <div className="form-group">
                <label>Height (cm) *</label>
                <input 
                  name="height" 
                  type="number" 
                  value={formData.height} 
                  onChange={handleChange} 
                  required 
                />
              </div>
              <div className="form-group">
                <label>Bust (cm)</label>
                <input 
                  name="bust" 
                  type="number" 
                  value={formData.bust} 
                  onChange={handleChange} 
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Waist (cm)</label>
                <input 
                  name="waist" 
                  type="number" 
                  value={formData.waist} 
                  onChange={handleChange} 
                />
              </div>
              <div className="form-group">
                <label>Hips (cm)</label>
                <input 
                  name="hips" 
                  type="number" 
                  value={formData.hips} 
                  onChange={handleChange} 
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Shoe Size (EU)</label>
                <input 
                  name="shoeSize" 
                  value={formData.shoeSize} 
                  onChange={handleChange} 
                />
              </div>
              <div className="form-group">
                <label>Dress Size</label>
                <input 
                  name="dressSize" 
                  value={formData.dressSize} 
                  onChange={handleChange} 
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Hair Color</label>
                <input 
                  name="hairColor" 
                  value={formData.hairColor} 
                  onChange={handleChange} 
                />
              </div>
              <div className="form-group">
                <label>Eye Color</label>
                <input 
                  name="eyeColor" 
                  value={formData.eyeColor} 
                  onChange={handleChange} 
                />
              </div>
            </div>
          </div>
        );

      case 7:
        return (
          <div className="form-section">
            <h3><span className="section-number">7</span> Travel & Documentation</h3>
            
            <div className="form-group">
              <label>US Status *</label>
              <select 
                name="usStatus" 
                value={formData.usStatus} 
                onChange={handleChange}
                required
              >
                <option value="">Select</option>
                <option>US Citizen</option>
                <option>Green Card Holder</option>
                <option>Work Visa</option>
                <option>Student Visa</option>
                <option>Tourist Visa</option>
                <option>No US Status</option>
              </select>
            </div>

            <div className="form-group">
              <label>Passports (Countries)</label>
              <input 
                name="passports" 
                value={formData.passports} 
                onChange={handleChange}
                placeholder="e.g., USA, Canada"
              />
            </div>

            <div className="form-group">
              <label>Multiple Nationalities?</label>
              <select 
                name="multipleNationalities" 
                value={formData.multipleNationalities} 
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option>Yes</option>
                <option>No</option>
              </select>
            </div>

            <div className="form-group">
              <label>Willing to Travel to USA?</label>
              <select 
                name="travelUSA" 
                value={formData.travelUSA} 
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option>Yes</option>
                <option>No</option>
              </select>
            </div>

            <div className="form-group">
              <label>Willing to Travel Internationally?</label>
              <select 
                name="travelIntl" 
                value={formData.travelIntl} 
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option>Yes</option>
                <option>No</option>
              </select>
            </div>
          </div>
        );

      case 8:
        return (
          <div className="form-section">
            <h3><span className="section-number">8</span> THEOMETRICS Overview</h3>
            
            <div className="form-group">
              <label>Have you received an overview of THEOMETRICS? *</label>
              <select 
                name="overviewReceived" 
                value={formData.overviewReceived} 
                onChange={handleChange}
                required
              >
                <option value="">Select</option>
                <option>Yes</option>
                <option>No</option>
              </select>
            </div>

            <div className="form-group">
              <label>Have you watched the THEOMETRICS intro video? *</label>
              <select 
                name="videoReceived" 
                value={formData.videoReceived} 
                onChange={handleChange}
                required
              >
                <option value="">Select</option>
                <option>Yes</option>
                <option>No</option>
              </select>
            </div>

            <div className="form-group">
              <label>Do you want to participate in THEOMETRICS? *</label>
              <select 
                name="wantsToParticipate" 
                value={formData.wantsToParticipate} 
                onChange={handleChange}
                required
              >
                <option value="">Select</option>
                <option>Yes</option>
                <option>No</option>
                <option>Maybe</option>
              </select>
            </div>

            <div className="form-group">
              <label>What do you understand THEOMETRICS to be?</label>
              <textarea 
                name="understandingDescription" 
                value={formData.understandingDescription} 
                onChange={handleChange}
                rows="4"
              />
            </div>
          </div>
        );

      case 9:
        return (
          <div className="form-section">
            <h3><span className="section-number">9</span> Business & Employment</h3>
            
            <div className="form-group">
              <label>Do you currently own a business? *</label>
              <select 
                name="ownedBusiness" 
                value={formData.ownedBusiness} 
                onChange={handleChange}
                required
              >
                <option value="">Select</option>
                <option>Yes</option>
                <option>No</option>
              </select>
            </div>

            {formData.ownedBusiness === 'Yes' && (
              <div className="form-group">
                <label>Business Description</label>
                <textarea 
                  name="businessDescription" 
                  value={formData.businessDescription} 
                  onChange={handleChange}
                  rows="3"
                />
              </div>
            )}

            <div className="form-group">
              <label>Are you interested in starting a business with THEOMETRICS? *</label>
              <select 
                name="wantsBusiness" 
                value={formData.wantsBusiness} 
                onChange={handleChange}
                required
              >
                <option value="">Select</option>
                <option>Yes</option>
                <option>No</option>
                <option>Maybe</option>
              </select>
            </div>

            <div className="form-group">
              <label>Do you have a business idea? *</label>
              <select 
                name="hasIdea" 
                value={formData.hasIdea} 
                onChange={handleChange}
                required
              >
                <option value="">Select</option>
                <option>Yes</option>
                <option>No</option>
              </select>
            </div>

            {formData.hasIdea === 'Yes' && (
              <>
                <div className="form-group">
                  <label>Describe Your Idea</label>
                  <textarea 
                    name="ideaDescription" 
                    value={formData.ideaDescription} 
                    onChange={handleChange}
                    rows="3"
                  />
                </div>

                <div className="form-group">
                  <label>Do you have a plan for your idea?</label>
                  <select 
                    name="hasPlan" 
                    value={formData.hasPlan} 
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    <option>Yes</option>
                    <option>No</option>
                    <option>In Progress</option>
                  </select>
                </div>
              </>
            )}

            <div className="form-group">
              <label>Employment Status *</label>
              <select 
                name="employmentStatus" 
                value={formData.employmentStatus} 
                onChange={handleChange}
                required
              >
                <option value="">Select</option>
                <option>Employed Full-Time</option>
                <option>Employed Part-Time</option>
                <option>Self-Employed</option>
                <option>Freelancer</option>
                <option>Student</option>
                <option>Unemployed</option>
              </select>
            </div>

            <div className="form-group">
              <label>Current Employer (if applicable)</label>
              <input 
                name="employer" 
                value={formData.employer} 
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Weekly Availability (hours)</label>
              <input 
                name="weeklyAvailability" 
                type="number" 
                value={formData.weeklyAvailability} 
                onChange={handleChange}
                placeholder="e.g., 10"
              />
            </div>

            <div className="form-group">
              <label>Preferred Contract Type</label>
              <select 
                name="contractType" 
                value={formData.contractType} 
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option>Full-Time</option>
                <option>Part-Time</option>
                <option>Project-Based</option>
                <option>Flexible</option>
              </select>
            </div>
          </div>
        );

      case 10:
        return (
          <div className="form-section">
            <h3><span className="section-number">10</span> Upload Media</h3>
            
            <div className="form-group">
              <label>Headshot *</label>
              <input 
                type="file" 
                name="headshot" 
                accept="image/*" 
                onChange={handleFileUpload}
                required
              />
              {formData.headshot && <p className="file-uploaded">✓ Uploaded</p>}
            </div>

            <div className="form-group">
              <label>Full Body Photo *</label>
              <input 
                type="file" 
                name="fullBody" 
                accept="image/*" 
                onChange={handleFileUpload}
                required
              />
              {formData.fullBody && <p className="file-uploaded">✓ Uploaded</p>}
            </div>

            <div className="form-group">
              <label>Portfolio Images (up to 5)</label>
              <input 
                type="file" 
                name="portfolioImages" 
                accept="image/*" 
                multiple 
                onChange={handleFileUpload}
              />
              {formData.portfolioImages.length > 0 && (
                <p className="file-uploaded">✓ {formData.portfolioImages.length} files uploaded</p>
              )}
            </div>

            <div className="form-group">
              <label>Introduction Video (optional)</label>
              <input 
                type="file" 
                name="introVideo" 
                accept="video/*" 
                onChange={handleFileUpload}
              />
              {formData.introVideo && <p className="file-uploaded">✓ Uploaded</p>}
            </div>
          </div>
        );

      case 11: // ⭐ НОВИЙ КРОК - CONSENT
        return (
          <div className="form-section">
            <h3><span className="section-number">11</span> Consent</h3>
            
            <div className="form-group">
              <label style={{display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer'}}>
                <input 
                  type="checkbox" 
                  checked={consentChecked}
                  onChange={(e) => setConsentChecked(e.target.checked)}
                  required
                  style={{width: 'auto', margin: 0}}
                />
                <span>I confirm that all information is correct and consent to be contacted for casting purposes via GENESIS.</span>
              </label>
            </div>
          </div>
        );

      default:
        return <p>Unknown section</p>;
    }
  };

  return (
    <div className="casting-container">
      <div className="casting-form">
        <div className="casting-header">
          <h2>Casting Call for Olympic Angels by Theo</h2>
          <p>We are excited to welcome new Olympic Angels by Theo. Please complete all 11 sections carefully.</p>
</div>

        {renderSection()}

        <div className="navigation-buttons">
          {currentStep > 1 && (
            <button 
              className="btn-prev"
              onClick={() => setCurrentStep(prev => prev - 1)}
            >
              Previous
            </button>
          )}
          
          {currentStep < 11 ? (
            <button 
              className="btn-next"
              onClick={() => setCurrentStep(prev => prev + 1)}
            >
              Next
            </button>
          ) : (
            <button 
              className="btn-submit" 
              onClick={handleSubmit}
              disabled={submitting || !consentChecked}
            >
              {submitting ? 'Submitting...' : 'Submit Application'}
            </button>
          )}

          <button 
            className="btn-cancel"
            onClick={() => onNavigate('home')}
          >
            Cancel
          </button>
        </div>

        <p style={{ textAlign: 'center', color: '#6c757d', marginTop: '20px', fontSize: '14px' }}>
          Step {currentStep} of 11
        </p>
      </div>
    </div>
  );
}

export default CastingApplicationPage;
